import React, { useState } from 'react';
import BulletButton from '../../../../components/BulletButton';
import styles from './EmailReceipt.module.css';
import PopupHeader from '../../../../components/PopupHeader';
import strings from '../../../../globalization';

const EmailReceipt = (props) => {
  const { onPressEmailReceipt = () => { }, closePopup } = props;
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const onPressDone = () => {
    let isValid = false;
    isValid = validateEmail(email);
    if (isValid) {
      onPressEmailReceipt(email);
    } else {
      setError(strings.PopupContentWrapper_email_error);
    }
  };

  const validateEmail = email => {
    // eslint-disable-next-line max-len
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  return (
    <div className={styles.container}>
      <PopupHeader onClose={closePopup} />
      <div className={styles.wrapper}>
        <span className={styles.label}>Please enter your email address</span>
        <input
          type={'email'}
          value={email}
          onChange={e => setEmail(e.target.value)}
          className={styles.input}
        />
        <span className={styles.errorTxt}>{error}</span>
        <BulletButton
          direction={'right'}
          triangleBgColor={'#6AB301'}
          buttonStyle={styles.noReceiptBackground}
          onClick={onPressDone}
        >
          <span className={styles.text}>DONE</span>
        </BulletButton>
      </div>
    </div>
  )
}

export default EmailReceipt;
